/* 系統配置相關接口 */

import request from '@/utils/http/request'


/**
 * 文件上傳
 * @param {String} bizType 文件類型 avatar-用戶頭像、ifBG-卡片背景圖、cert-接口參數
 * @returns 
 */
export async function oss_files(data) {
    return await request({
        url: `/common/upload`,
        method: 'post',
        data: data,
        headers: { 'Content-Type': 'multipart/form-data;charset=utf-8' },
    })
}


export async function get_order_platform({ }) {
    return await request.post('/common/basic/get_order_platform', {}, {
        noAuth: false
    });
}
